import { createFileRoute } from "@tanstack/react-router";
import { hooks as h } from "@/hooks";
import { LabelsManagementTable } from "@/features/builder/components/LabelsManagementTable";

const LabelsBuilderPage = () => {
    h.useNav([
        { label: "Builder", route: { to: "/builder" } },
        { label: "Labels", route: { to: "/builder/labels" } },
    ]);

    return (
        <div className="space-y-6 p-2 md:p-4">
            <div>
                <h1 className="font-semibold text-3xl tracking-tight">Labels</h1>
                <p className="text-muted-foreground">
                    Manage diary labels and their resource links. Labels group diaries by study or trial. Links appear
                    on diary cards for patients.
                </p>
            </div>

            <LabelsManagementTable />
        </div>
    );
};

export const Route = createFileRoute("/_app/builder/labels/")({
    component: LabelsBuilderPage,
});
